import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import SentryErrorBoundary from './services/sentry/components/SentryErrorBoundary';
import { initializeModuleFederationRuntime } from './moduleFederation/moduleFederationRuntime';

initializeModuleFederationRuntime();

const root = createRoot(document.getElementById('root'));
root.render(
  <SentryErrorBoundary errorArea="main-app">
    <App />
  </SentryErrorBoundary>
);

serviceWorker.unregister();
